/** @module csi/heading/LabeledNumber */
define([
	"dojo/_base/declare",
	"csi/heading/Number",
	"csi/reflection",
	"csi/types",
	"csi/xml"
], function(declare, NumberRen, reflection, types, xml) {

	return declare(NumberRen, {

		// Boolean: tells if newline character gets prepended to string
		prependNewLine: false,

		/**
		 * @override
		 * Display localized name of attribute before the value, hide if attribute is hidden
		 */
		toValue: function(ctx, h) {
			const rc = reflection.getClass(ctx.getNodeType());
			const rca = rc.getAttribute(h.m_id);
			if (rca.isHidden) {
				return "";
			}

			// Conditional new line separator
			if (this.prependNewLine == true) {
				h.m_separator = "\n";
			}


			const x = this.inherited(arguments);
			const name = h.m_name;

			return `${name}: ${x}`;
		}
	});
});